import React from 'react';
import ErrorProvider from './ErrorProvider';
import ThemeProvider from './ThemeProvider';
import QueryProvider from './QueryProvider';
import { SnackbarProvider } from 'widgets';

const AppProviders = ({ children }) => (
  <ErrorProvider>
    <ThemeProvider>
      <SnackbarProvider>
        <QueryProvider>{children}</QueryProvider>
      </SnackbarProvider>
    </ThemeProvider>
  </ErrorProvider>
);

export default AppProviders;
